/**
 * Created by Jiu Chen on 01/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 * update by Marucs Zhao 2023/1/9, support show primaryEmail for user list.
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { UsersService } from '@tamalelibs/services/users.service';
import { UsersActionTypes } from '../actions/users.actions';

@Injectable()
export class UsersEffects {

    constructor(
        private _actions$: Actions,
        private _usersService: UsersService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(UsersActionTypes.INITIALIZE),
        switchMap(() => {
            return this._usersService.getAll().pipe(
                map(response => response['entity-list']),
                map(response => {
                    const userList = response.map(element => {
                        return {
                            id: element.id,
                            name: element['long-name'],
                            shortName: element['short-name'],
                            aliases: element['aliases'].data,
                            primaryEmail: element['primary-email'],
                        };
                    });
                    return {
                        type: UsersActionTypes.INITIALIZE_SUCCESS,
                        payload: userList
                    };
                })
            );
        })
    ));

    loadUserSettingEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(UsersActionTypes.LOAD_USER_SETTING),
        switchMap(() => {
            return this._usersService.getUserSetting().pipe(
                map(response => {
                    return {
                        type: UsersActionTypes.LOAD_USER_SETTING_SUCCESS,
                        payload: response
                    };
                })
            );
        })
    ));

    updateUserSettingEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(UsersActionTypes.UPDATE_USER_SETTING),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._usersService.updateUserSetting(payload).pipe(
                map(response => {
                    return {
                        type: UsersActionTypes.UPDATE_USER_SETTING_SUCCESS,
                        payload: response
                    };
                })
            );
        })
    ));
}
